// Re-exportar el cliente API por defecto
import api, { API_BASE_URL, AUTH_TOKENS_EVENT, emitAuthTokensEvent } from './apiClient';
export type { AuthTokensEventDetail } from './apiClient';
export default api;
export { API_BASE_URL, AUTH_TOKENS_EVENT, emitAuthTokensEvent };

// Re-exportar todos los servicios
export { authService } from './authService';
export { petService } from './petService';
export { petAIService } from './petAIService';
export { medicalService } from './medicalService';
export { fileService } from './fileService';
export { userService, appRatingService } from './userService';
export { veterinarianService } from './clinicService';
export { adminService } from './adminService';
export { systemService } from './systemService';
export { inventoryService } from './inventoryService';
export { notificationService } from './notificationService';
export { appointmentService } from './appointmentService';
export { billingService } from './billingService';
export { clinicService } from './clinicService';
export { subscriptionService } from './subscriptionService';
export { emailService } from './emailService';
export { suggestionService } from './suggestionService';
export { reminderService } from './reminderService';
export { referralService } from './referralService';
export { privacyService, legalService } from './privacyService';